import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MembersFileSendComponent } from 'src/app/members/members-file-send/members-file-send.component';
import { LoaderComponent } from '../loader.component';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  loaders = [];
  constructor(private matDialog: MatDialog) {}

  showLoader() {
    const currentTime = new Date().getTime().toString();
    this.loaders.push(currentTime);
    this.matDialog
      .open(LoaderComponent, {
        width: '170px',
        height: '170px',
        autoFocus: true,
        panelClass: 'load',
        disableClose: true,
        id: currentTime,
      })
      .afterClosed();
  }

  closeLoader() {
    setTimeout(() => {
      const index = this.loaders.pop();
      if (this.matDialog.getDialogById(index)) {
        this.matDialog.getDialogById(index).close();
      }
    }, 1000);
  }
}
